import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { StoreProvider } from './store'
import {initFontAwesome} from './utils'
import { GQLContext } from './utils/GQLContext'
import {DepotoCore, ENDPOINT, getEndpoint} from 'depoto-core'
import './index.css'
import {Router} from "./views/Router.tsx";
import {Thunder} from "../zeus";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from '@sentry/react'

declare global {
  interface Window {
    _depoto: any
    depotoEnv?: 'prod' | 'stage' | 'dev' | 'custom'
    lastRoute: string
    batchGroupStatus: { [groupId: string]: { status: any; errors: any } }
    weightHistory: string[]
  }
}

Sentry.init({
  dsn: 'https://4973dc8c494decde1173e52515cae513@o780420.ingest.us.sentry.io/4511053837631488',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.NODE_ENV || 'development',
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

initFontAwesome()
const core: DepotoCore = new DepotoCore('depoto-checkout-v2')
const queryClient = new QueryClient()

export const gql = Thunder(async query => {
  const response = await fetch(getEndpoint(ENDPOINT.GRAPHQL_POST, core.services.oauth.getSession()), {
    body: JSON.stringify({ query }),
    method: 'POST',
    // @ts-ignore trust me bro
    headers: core.services.http.getAuthorizationHeaders(),
  })

  if (!response.ok) {
    return new Promise((resolve, reject) => {
      response
        .text()
        .then(text => {
          try {
            reject(JSON.parse(text))
          } catch (err) {
            reject(text)
          }
        })
        .catch(reject)
    })
  }

  const json = await response.json()

  // Simple BE error handling
  if (json.errors && Array.isArray(json.errors)) {
    return Promise.reject(json.errors.map((e: any) => e.message).join(', '))
  }

  return json.data
})

createRoot(document.getElementById('root')!).render(
  <GQLContext.Provider value={gql}>
    <QueryClientProvider client={queryClient}>
      <StrictMode>
        <StoreProvider>
          {/*<BrowserRouter>*/}
            <Router core={core} />
          <ToastContainer limit={3} autoClose={1500} />
          {/*</BrowserRouter>*/}
        </StoreProvider>
      </StrictMode>
    </QueryClientProvider>
  </GQLContext.Provider>
)
